import { Box, Text } from '@fhs-legacy/universal-components';
import { theme } from 'styles/configure-theme';

export const Wrapper = Box.withConfig({
  flexDirection: 'row',
  marginTop: '$4',
  marginBottom: '$2',
});

export const Badge = Box.withConfig({
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: '$6',
  paddingX: '$2',
  backgroundColor: theme.token('background-chip'),
  borderRadius: theme.token('border-radius-chip'),
  gap: '$1',
});

export const Label = Text.withConfig({
  variant: 'copyThree',
  color: theme.token('text-reversed'),
});
